import React, { useMemo } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';

/**
 * Wraps MRT tables in a theme where `background.default` is remapped to
 * `background.paper`. MRT derives its row/cell/container/toolbar backgrounds
 * from `background.default`; remapping it here (and only here) makes every
 * MRT surface render paper-white without touching the global palette or the
 * grey page backdrop the rest of the app relies on.
 */
export const MrtThemeProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const outer = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme(outer, {
        palette: {
          background: { default: outer.palette.background.paper },
        },
      }),
    [outer],
  );

  return <ThemeProvider theme={tableTheme}>{children}</ThemeProvider>;
};
